import React from 'react'
import {About, Header, Projects} from '../'
import {AppWrap} from '../../wrapper';
const Home = () => {
  return (
    <div>
        <Header />
        <About />
        <Projects />
    </div>
  )
}

export default Home;